var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuYoubookerD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_youbooker_d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 25,
    viewBox: "0 0 70 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_207006",
    "data-name": "\\uC0AC\\uAC01\\uD615 207006",
    width: 70,
    height: 25,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_youbooker_active",
    transform: "translate(12.947 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_youbooker",
    transform: "translate(3.053 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8593",
    "data-name": "\\uD328\\uC2A4 8593",
    d: "M49.061,13.108A4.109,4.109,0,1,1,44.952,9a4.109,4.109,0,0,1,4.109,4.108",
    transform: "translate(-25.844 -8.999)",
    fill: "#555",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4494",
    "data-name": "\\uADF8\\uB8F9 4494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8497",
    "data-name": "\\uD328\\uC2A4 8497",
    d: "M0,8.952a8.95,8.95,0,1,1,17.9,0Z",
    transform: "translate(10 10.969)",
    fill: "#555",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuYoubookerD);
export default __webpack_public_path__ + "static/media/menu_youbooker_d.7464cc7ada9a37900e0bd1375bef8e19.svg";
export { ForwardRef as ReactComponent };